import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import OtpInput from 'react-otp-input';
import ResendTimer from './ResendTimer';

function ClaimBS() {
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [inProgress, setInProgress] = useState(false);

  useEffect(() => {
    return () => setOtp('');
  }, []);

  return (
    <div className={styles.claimBS}>
      <div className={styles.enterOtp}>ENTER OTP</div>
      <div className={styles.sentTo}>Sent to mobile no XX 9455</div>
      <div className={styles.otpRow}>
        <OtpInput
          shouldAutoFocus
          value={otp}
          onChange={(value) => {
            setOtpError('');
            setOtp(value);
          }}
          numInputs={4}
          containerStyle={{
            justifyContent: 'space-between',
            gap: 20,
          }}
          renderInput={(props, index) => {
            const { value, style } = props;
            return (
              <input
                {...props}
                className={styles.otpField}
                id={`otpBox${index}`}
                inputMode="numeric"
                placeholder="-"
                style={{
                  ...style,
                  width: '100%',
                  height: 64,
                  borderRadius: 8,
                  background: '#162143',
                  border: value ? '1px solid #FFA586' : 'none',
                }}
              />
            );
          }}
        />
      </div>
      {otpError?.length ? (
        <div className={styles.otpError}>{otpError}</div>
      ) : null}
      <ResendTimer />
      <button
        onClick={() => {
          setInProgress(true);
          setTimeout(() => {
            if (Number(otp) !== 4444) {
              setOtpError('Invalid OTP, Enter the correct OTP !');
            }
            setInProgress(false);
          }, 1000);
        }}
        style={{
          opacity: inProgress ? 0.6 : 1,
        }}
        disabled={inProgress || otp.length < 4}
        className={`${styles.btn} ${
          otp.length >= 4 ? styles.submitBtn : styles.btnDisabled
        }`}
      >
        {inProgress ? 'Checking Offer' : 'SUBMIT'}
      </button>
    </div>
  );
}

export default React.memo(ClaimBS);
